module.exports = __webpack_public_path__ + "style/img/RE_icon_Shoot.c06c6a15.png";